function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941176%,92.941176%,95.294118%)",
      fillOpacity: 1
    },
    d: "M 39 40.601562 L 9 40.601562 C 7.5 40.601562 6 39.898438 5.101562 38.800781 C 3.300781 36.5 3.601562 33.300781 5.699219 31.5 C 8 29.601562 9.300781 26.699219 9.300781 23.699219 L 9.300781 18.601562 C 9.300781 11.898438 13.898438 6.101562 20.199219 4.398438 L 20.199219 4 C 20.199219 1.898438 21.898438 0.199219 24 0.199219 C 26.101562 0.199219 27.800781 1.898438 27.800781 4 L 27.800781 4.300781 C 34.101562 6 38.699219 11.800781 38.699219 18.5 L 38.699219 23.601562 C 38.699219 26.601562 40 29.398438 42.300781 31.300781 C 43.5 32.300781 44.199219 33.699219 44.199219 35.398438 C 44.199219 38.300781 41.898438 40.601562 39 40.601562 Z M 24.199219 7.699219 L 22.5 8 C 17.300781 8.800781 13.300781 13.300781 13.300781 18.601562 L 13.300781 23.699219 C 13.300781 27.898438 11.5 31.800781 8.300781 34.5 C 7.800781 34.898438 7.800781 35.699219 8.199219 36.199219 C 8.398438 36.398438 8.699219 36.5 9 36.5 L 39 36.5 C 39.699219 36.5 40.199219 36 40.199219 35.300781 C 40.199219 34.699219 39.898438 34.5 39.800781 34.398438 L 39.699219 34.300781 C 36.5 31.601562 34.699219 27.601562 34.699219 23.5 L 34.699219 18.398438 C 34.699219 13.101562 30.699219 8.5 25.5 7.800781 Z M 24.199219 7.699219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941176%,92.941176%,95.294118%)",
      fillOpacity: 1
    },
    d: "M 24 47.800781 C 19 47.800781 14.800781 44.101562 13.800781 38.898438 L 13.398438 36.5 L 34.601562 36.5 L 34.199219 38.898438 C 33.199219 44.101562 29 47.800781 24 47.800781 Z M 18.601562 40.5 C 19.699219 42.5 21.699219 43.800781 24 43.800781 C 26.300781 43.800781 28.300781 42.5 29.398438 40.5 Z M 18.601562 40.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.3be244fbca4b04328c2567c9adec5134.svg";
export { ForwardRef as ReactComponent };